const styles = theme => ({
  formItemWrapper: {
    marginTop: theme.spacing.unit
  },
  gifContainer: {
    margin: theme.spacing.unit,
    textAlign: 'center'
  },
  gif: {
    display: 'inline-block',
    textAlign: 'center',
    width: '100%',
    heigth: '100%'
  },
  link: {
    margin: 0,
    padding: 0,
    justifyContent: 'left',
    textDecoration: 'none'
  }
});

export default styles;
